// extracted by mini-css-extract-plugin
module.exports = {"container":"TeamCard_container__16Coh","logo":"TeamCard_logo__2Xy5j"};